import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FeederContractModel } from '@bo-client/activation-management/feeder-contract/model/feeder-contract.model';
import { AuthenticationService } from '@bo-client/core';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { CreateFormsFcContractConfirmationService } from '@bo-client/activation-management/feeder-contract/forms/create-forms-fc-contract-confirmation.service';
import { ErrorsFormsService } from '@bo-client/shared/form-errors/errors-forms.service';
import { ConfirmationRequestFormBase } from '@bo-client/shared/base-components/confirmation-request-form.base';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-fc-contract-confirmation-form',
  templateUrl: './fc-contract-confirmation-form.component.html',
  styleUrls: ['./fc-contract-confirmation-form.component.scss']
})
export class FcContractConfirmationFormComponent
  extends ConfirmationRequestFormBase<FeederContractModel>
  implements OnInit, OnDestroy
{
  @Output() onErrorsChanged = new EventEmitter<any>();
  public compUnsubs$ = new Subject<void>();
  protected feederContract: FeederContractModel;

  public constructor(
    protected authenticationService: AuthenticationService,
    protected dataShareService: DataShareService,
    protected errorsFormsService: ErrorsFormsService,
    protected createFormsFcContractConfirmationService: CreateFormsFcContractConfirmationService
  ) {
    super(authenticationService, dataShareService, errorsFormsService);
  }
  ngOnInit(): void {}

  loadFormWithModel(result: FeederContractModel) {
    this.feederContract = result;
    this.formGroup = this.createFormsFcContractConfirmationService.createFCContractConfirmationOfferForm(
      this.feederContract
    );
  }

  hookErrors() {
    // entry Point to check specific errors
    console.log('emitting errors', this.errorFormList);
    this.errorsFormsService.updateErrorListAccordingCondition(
      this.formGroup.get('ustPflichtig').value &&
        this.formGroup.get('ustNr').value == '' &&
        this.formGroup.get('taxNr').value == '',
      'ustNrORtaxNr',
      this.errorFormList
    );
    this.onErrorsChanged.emit(this.errorFormList);
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
